import React, { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import RefinanceHeroSection from './components/RefinanceHeroSection';
import WhyRefinanceSection from './components/WhyRefinanceSection';
import RefinanceProgramsSection from './components/RefinanceProgramsSection';
import RefinanceQuestionsSection from './components/RefinanceQuestionsSection';
import RefinanceCTASection from './components/RefinanceCTASection';

export default function RefinanceOptions() {
  useEffect(() => {
    // Set page-specific meta tags
    document.title = 'Refinance Options | Tony Monteiro Mortgage Agent';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Explore mortgage refinancing options in Ontario with expert guidance from Tony Monteiro. Lower rates, access equity, and consolidate debt with professional refinance solutions.');
    }
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'mortgage refinancing Ontario, refinance options Waterloo, home equity access, debt consolidation mortgage, lower mortgage rates, refinance expert Ontario');
    
    // Set canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://mortgagesforyoubytony.ca/refinance-options');

    // Add JSON-LD schema
    const existingSchema = document.querySelector('script[type="application/ld+json"]');
    if (existingSchema) {
      existingSchema.remove();
    }
    
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = '{"@context":"https://schema.org","@graph":[{"@type":"Service","name":"Mortgage Refinancing Services","serviceType":"Mortgage Refinancing","provider":{"@type":"LocalBusiness","@id":"https://mortgagesforyoubytony.ca/#org"},"areaServed":["Waterloo","Brant County","Wellington County","Greater Golden Horseshoe"],"url":"https://mortgagesforyoubytony.ca/refinance-options","offers":{"@type":"Offer","price":"0.00","priceCurrency":"CAD","description":"Free consultation for mortgage refinancing in Ontario."}},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://mortgagesforyoubytony.ca/"},{"@type":"ListItem","position":2,"name":"Refinance Options","item":"https://mortgagesforyoubytony.ca/refinance-options"}]}]}';
    document.head.appendChild(schemaScript);
  }, []);

  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <main>
        <RefinanceHeroSection />
        <WhyRefinanceSection />
        <RefinanceProgramsSection />
        <RefinanceQuestionsSection />
        <RefinanceCTASection />
      </main>
      <Footer />
    </div>
  );
};